import { Tabs, TabsProps } from 'antd';
import { FC } from 'react';

import { ITabsItem } from './interfaces';
import styles from './styles.module.scss';

type PropTypes = {
  items: ITabsItem[];
} & TabsProps;

const { TabPane } = Tabs;

const CardTabs: FC<PropTypes> = ({ items, className, ...restProps }) => {
  return (
    <Tabs
      {...restProps}
      type="card"
      className={`${styles.tabsContainer} ${className || ''}`}
    >
      {items.map((item) => (
        <TabPane tab={item.title} key={item.key}>
          {item.content}
        </TabPane>
      ))}
    </Tabs>
  );
};

export default CardTabs;
export type { ITabsItem };
